const route = () => '/loading';

export default route;
